import React from "react";
import style from "./BlogCard.module.css";
import { Card, Col } from "react-bootstrap";

const BlogCard = ({ blog }) => {
  const { img, description, name,link } = blog;
  return (
    <>
      <Col xm={12} sm={12} md={6} lg={4}>
        <Card className={`${style.blog__card} shadow p-3  bg-dark rounded `}>
          <Card.Img variant="top" className={`${style.blog__img} m-auto p-3`} src={img} />
          <Card.Body className={`${style.blog__content} text-center`}>
            <Card.Title
              className={`${style.blog__name} fw-bold text-light py-3`}
            >
              {name}
            </Card.Title>
            <Card.Text
              style={{ fontWeight: "500" }}
              className="text-start text-secondary"
            >
              {description}
            </Card.Text>
          </Card.Body>
          <a
            className={`${style.detailBtn} `}
            target="_blank."
            href={link}
          >
            Read Blog
          </a>
        </Card>
      </Col>
    </>
  );
};

export default BlogCard;
